import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { AzureSearchConfig } from './azure-search.config.js';

@NgModule({
    imports: [CommonModule],
    providers: [],
    declarations: [],
    exports: []
})
export class AzureSearchModule {
    static forRoot(config: AzureSearchConfig): ModuleWithProviders<AzureSearchModule> {
        return {
            ngModule: AzureSearchModule,
            providers: [
                {
                    provide: AzureSearchConfig,
                    useValue: config
                }
            ]
        };
    }
}
